import { render, staticRenderFns } from "./tabSix.vue?vue&type=template&id=742d11d8"
import script from "./tabSix.vue?vue&type=script&lang=js"
export * from "./tabSix.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports